<template>
  <div class="scale-wrapper">
    <router-view />
  </div>
</template>

<script>
export default {
  
};
</script>

<style lang="scss">
html,
body {
  margin: 0;
  padding: 0;
}
.scale-wrapper {
  width: 100%;
  height: auto;
  margin: 0 auto;
}
</style>
